import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-4xl font-bold text-slate-900 mb-8" data-testid="privacy-title">Privacy Policy</h1>
            <p className="text-sm text-slate-500 mb-8">Last updated: March 2026</p>

            <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">1. Information We Collect</h2>
                <p>When you use AirVia, we collect information you provide directly, including your name, email address, phone number, travel preferences (departure city, arrival city, number of tickets, travel frequency), and any additional notes you share through our interest form.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">2. How We Use Your Information</h2>
                <p>We use your information to:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Create customized flight subscription plans based on your travel needs</li>
                  <li>Contact you regarding your subscription requests</li>
                  <li>Send confirmation emails and plan details</li>
                  <li>Improve our services and user experience</li>
                  <li>Communicate important updates about your subscription</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">3. Data Storage & Security</h2>
                <p>Your data is stored securely using industry-standard encryption. We use secure databases and follow best practices to protect your personal information from unauthorized access, alteration, or disclosure.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">4. Information Sharing</h2>
                <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only with airline partners to facilitate your flight bookings as part of your subscription plan.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">5. Cookies</h2>
                <p>Our website uses cookies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie preferences through your browser settings.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">6. Your Rights</h2>
                <p>You have the right to access, update, or delete your personal information at any time. To exercise these rights, contact us at hello@airviaindia.com.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">7. Contact Us</h2>
                <p>For privacy-related queries, reach us at:</p>
                <p>Email: hello@airviaindia.com</p>
                <p>Address: OXFORD TOWER, 139/88 HAL OLD AIRPORT RD, H.A.L II Stage, Bengaluru 560008</p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
